import React from 'react';
import { useTranslation } from 'react-i18next';

export const SLOGANS = { es: 'Conecta, desarrolla, trasciende', en: 'Connect. Develop. Transcend.' };

export const useSlogan = () => {
  const { i18n } = useTranslation();
  return (i18n.language || 'es').startsWith('es') ? SLOGANS.es : SLOGANS.en;
};

// Language-aware full lockup: SVG assets — the untouched approved core raster
// (symbol + wordmark, bit-identical) plus the tagline as true vector paths in
// the previous high-quality EN treatment (Inter 600, 0.08em tracking, #2AA9A9).
// Resolution-independent on every display; ES improved to the EN master spec.
export const BrandLockup = ({ className = '' }) => {
  const { i18n } = useTranslation();
  const es = (i18n.language || 'es').startsWith('es');
  if (es) {
    return (
      <img src="/brand/cth_lockup_es.svg" alt={`Corporate Talent Hub — ${SLOGANS.es}`}
           className={className} data-testid="brand-lockup-es" />
    );
  }
  return (
    <img src="/brand/cth_lockup_en.svg" alt={`Corporate Talent Hub — ${SLOGANS.en}`}
         className={className} data-testid="brand-lockup-en" />
  );
};

// CTH Approved Logo (Founder package 2026-09-05) — exact assets, no reinterpretation.
// Dark surfaces use the approved white-tile square asset; light surfaces use the
// transparent symbol. Aspect ratio always preserved.
export const Logo = ({ variant = 'default', size = 'md' }) => {
  const sizes = {
    sm: { icon: 'h-7', tile: 'h-7 w-7', text: 'text-sm sm:text-base', sub: 'text-[10px] sm:text-xs' },
    md: { icon: 'h-9', tile: 'h-9 w-9', text: 'text-lg', sub: 'text-xs' },
    lg: { icon: 'h-11', tile: 'h-11 w-11', text: 'text-xl', sub: 'text-xs' },
  };
  const s = sizes[size];
  const light = variant === 'light';
  const textColor = light ? 'text-white' : 'text-foreground';

  return (
    <div className="flex items-center gap-2.5" data-testid="cth-logo">
      {light ? (
        <img
          src="/brand/icon-256.png"
          alt="CTH"
          className={`${s.tile} rounded-lg object-cover shadow-soft shrink-0`}
        />
      ) : (
        <img
          src="/brand/cth_symbol.png"
          alt="CTH"
          className={`${s.icon} w-auto shrink-0`}
        />
      )}
      <div className={`leading-tight ${size === 'sm' ? 'hidden min-[480px]:block' : ''}`}>
        <div className={`font-display font-bold tracking-tight whitespace-nowrap ${s.text} ${textColor}`}>
          Corporate Talent Hub
        </div>
      </div>
    </div>
  );
};
